const routes = {
  createPurchaseInvoice: 'purchase',
  getPurchaseInvoices: 'purchase',
  getPurchaseInvoiceById: 'purchase/',
  updatePurchaseInvoice: 'purchase/',
  deletePurchaseInvoice: 'purchase/',
};

export default routes